import { render, staticRenderFns } from "./close-list.vue?vue&type=template&id=639c649c&"
import script from "./close-list.vue?vue&type=script&lang=js&"
export * from "./close-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports